import { Button } from '@/components/Button';
import { PhoneInput } from '@/components/PhoneInput';
import { Text } from '@/components/Text';
import { TextInput } from '@/components/TextInput';
import { useCompanyStore } from '@/stores/useCompanyStore';
import { Form } from 'formik';
import { useTranslation } from 'react-i18next';

export const CreateCompanyInformations = ({
  errors,
  touched,
}: {
  errors: { [key: string]: string | undefined };
  touched: { [key: string]: boolean | undefined };
}) => {
  const { t } = useTranslation();
  const { loading } = useCompanyStore();

  return (
    <div className="flex flex-col items-center justify-center md:items-start">
      <Text className="text-base font-medium text-sky-800">
        {t('createCompany:information.title')}
      </Text>
      <Form className="mt-4 grid w-full grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
        <TextInput
          label={t('createCompany:information.label.name')}
          name="name"
          type="text"
          placeholder={t('createCompany:information.placeholder.name')}
          error={!!touched.name && !!errors.name}
          isRequired
        />
        <TextInput
          label={t('createCompany:information.label.address')}
          name="address"
          type="text"
          placeholder={t('createCompany:information.placeholder.address')}
          error={!!touched.address && !!errors.address}
        />
        <TextInput
          label={t('createCompany:information.label.vat-number')}
          name="vat_number"
          type="text"
          placeholder={t('createCompany:information.placeholder.vat-number')}
          error={!!touched.vat_number && !!errors.vat_number}
        />
        <PhoneInput
          label={t('createCompany:information.label.phone')}
          name="phone"
          placeholder={t('createCompany:information.placeholder.phone')}
          error={!!touched.phone && !!errors.phone}
        />
        <TextInput
          label={t('createCompany:information.label.email')}
          name="email"
          type="email"
          placeholder={t('createCompany:information.placeholder.email')}
          error={!!touched.email && !!errors.email}
        />
        <TextInput
          label={t('createCompany:information.label.website')}
          name="website"
          type="text"
          placeholder={t('createCompany:information.placeholder.website')}
          error={!!touched.website && !!errors.website}
        />
        <div className="col-span-1 mt-4 w-full md:col-span-2">
          <Button type="submit" className="w-full lg:w-auto" disabled={loading}>
            {t('createCompany:information.submit')}
          </Button>
          <Text className="mt-2 text-sm font-light text-gray-500">
            {t('createCompany:information.note')}
          </Text>
        </div>
      </Form>
    </div>
  );
};
